import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, Clock } from 'lucide-react';
import HeroParticles from '../ui/HeroParticles';
import { useCountdown } from '../../hooks/useCountdown';
import { MASTERCLASS_DATETIME } from '../../data/masterclass';

/**
 * Segundo slide del carrusel del Home: promociona la Masterclass gratuita,
 * inspirado visualmente en el hero de src/pages/MasterClass.tsx (mismo fondo
 * de partículas, gradiente y paleta mc-*).
 */
const MasterClassPromoSlide: React.FC = () => {
  const { fechaLabel, horaLabel } = useCountdown(MASTERCLASS_DATETIME);

  return (
    <section className="relative flex h-screen items-center overflow-hidden bg-[#070c24]">
      <HeroParticles />
      <div
        className="pointer-events-none absolute -left-24 -top-32 h-[28rem] w-[28rem] rounded-full blur-3xl"
        style={{ background: 'radial-gradient(circle, rgba(218,35,157,.4), transparent 65%)' }}
      />
      <div
        className="pointer-events-none absolute -right-20 top-0 h-[30rem] w-[30rem] rounded-full blur-3xl"
        style={{ background: 'radial-gradient(circle, rgba(63,134,255,.36), transparent 65%)' }}
      />

      <div className="relative z-10 mx-auto max-w-7xl px-4 text-center text-white">
        <div className="mx-auto max-w-3xl">
          <span className="chip-mc mb-7 inline-flex items-center gap-2.5 rounded-full px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-white/80">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-mc-fuchsia opacity-70" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-mc-fuchsia" />
            </span>
            Masterclass gratuita · En vivo
          </span>

          <h1 className="font-display text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl md:text-6xl">
            De usar ChatGPT a trabajar con <span className="text-gradient-mc">Inteligencia Artificial</span>
          </h1>

          <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-white/80 md:text-xl">
            Una clase en vivo de 2 horas, 100% gratuita, para aprender a aplicar IA en tu trabajo con el Método
            WITS — aunque empieces desde cero.
          </p>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-2 text-xs text-white/60">
            <span className="chip-mc flex items-center gap-1.5 rounded-lg px-3 py-1.5">
              <Calendar size={14} className="text-mc-electric" />
              {fechaLabel}
            </span>
            <span className="chip-mc flex items-center gap-1.5 rounded-lg px-3 py-1.5">
              <Clock size={14} className="text-mc-electric" />
              {horaLabel} · Hora Perú
            </span>
          </div>

          <div className="mt-8 flex flex-col items-center gap-3">
            <Link to="/masterclass#registro" className="btn-mc-glow group inline-flex items-center gap-2 px-8 py-4">
              Inscríbete Gratis
              <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </Link>
            <Link to="/masterclass" className="text-sm font-medium text-white/70 underline-offset-4 hover:text-white hover:underline">
              Saber más
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MasterClassPromoSlide;
